export enum QueryParamsEnum {
	SEARCH_QUERY = 'q',
	SEARCH_BY_LETTER = 'q_by_letter',
	CONSULT_PROTOCOL_NUMBER = 'consult_protocol_number',
	CONSULT_INITIAL_DATE = 'consult_initial_date',
	CONSULT_END_DATE = 'consult_end_date',
	CITY_NAME = 'city_name',
	UF_CODE = 'uf_code',
	UF_NAME = 'uf_name',
	DISABILITY = 'disability',
	INCLUDE_NEIGHBORHOOD = 'include_neighborhood',
	STEP = 'step',
	SHIFT = 'shift',
	DATE_AT = 'date_at',
	BOOKING_TYPE = 'booking_type',
	AUTHORIZATION_STATUS = 'authorization_status',
	ORDER_BY = 'order_by',
	PROTOCOL_TYPE = 'protocol_type',
	STATUS = 'status',
	INITIAL_DATE = 'initial_date',
	FINAL_DATE = 'final_date',
	MONTH = 'month',
	YEAR = 'year',
	CATEGORY = 'category',
	CALENDAR_ACTIVE = 'calendar_active',
	LOCALITY_DISTANCE = 'locality_distance',
	DISTANCE_ORIGIN = 'distance_origin',
	SPECIALTY_NAME = 'specialty_name',
	AUTOCOMPLETE_QUERY = 'autocomplete_query',
	TYPE_LOCAL_NAME = 'type_local_name',
	SPECIALTY_CODE = 'specialty_code',
	PROCEDURE = 'cd_procedimento',
	SUB_SPECIALTY_CODE = 'sub_specialty_code',
	HAS_SUB_SPECIALTY = 'has_sub_specialty',
	IS_V2 = 'is_v2',
	REQUEST_SCHEDULE_PERMISSION_CITY = 'request_schedule_permission_city',
	EXAM_TYPE = 'exam_type',
	SERVICE_TYPE = 'service_type',
	NETWORK_TYPE = 'network_type',
	NETWORK_CODE = 'network_code',
	DISTRICT_NAMES = 'district_names',
	COORDINATES = 'coordinates',
	REFUND_THERAPY_MODE = 'refund_therapy_mode',
	COMING_FROM = 'coming_from',
	DISTANCE = 'distance',
	PROFESSIONAL_CODE = 'professional_code',
	PROFESSIONAL_NAME = 'professional_name',
}
